<template>
  <div
    :class="{ active: activeMenu }"
    class="mobile-navigation-wrapper"
  >
    <div
      :class="{ active: activeMenu }"
      class="page-overlay"
      @click="triggerMenu()"
    />
    <button
      :class="mobileMenuDisplayPort"
      class="btn btn-md mobile-navigation-button"
      @click="triggerMenu()"
    >
      Menu
    </button>

    <div
      :class="mobileMenuDisplayPort"
      class="mobile-navigation"
    >
      <div
        :class="mobileMenuPosition"
        class="mobile-navigation-container"
      >
        <!-- Login, My Portal, Cart, Logout-->

        <div class="close-menu">
          <div @click="triggerMenu()">
            Close Menu
          </div>
        </div>
        <div class="actions">
          <ecommerce-cart-block v-if="ecommerceEnabled" />
          <!-- Login Form -->
          <user-login-popup v-if="!loggedIn" />
          <!-- My Portal Link -->
          <page-element-user-my-account v-if="loggedIn" />
          <!-- Logout Link -->

          <!-- user-logout v-if="loggedIn"/ -->
        </div>
        <!-- Search -->
        <div
          v-if="searchActive"
          class="mobile-search"
        >
          <b-input-group>
            <b-form-input placeholder="Site Search" />
            <b-input-group-append>
              <b-btn variant="info">
                <font-awesome-icon icon="searchIcon" />
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </div>

        <!-- Primary Menu -->
        <div class="primary">
          <main-menu menu-style="mobile" />
          <main-menu
            menu-style="mobile"
            menu-name="main-menu-2"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavMenu from 'components/generic/menus/nav-menu'
import MegaMenu from 'components/generic/menus/mega-menu'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
library.add(faSearch)

export default {
  name: 'mobile-nav-mobile-menu',
  components: {
    NavMenu,
    MegaMenu
  },
  data: function() {
    return {
      menuDisplayed: false,
      mobileMenuPosition: 'right-draw',
      showSidebar: false,
      collapsed: true,
      menuHidden: true,
      mobileMenuDisplayPort: 'd-block d-lg-none',
      desktopMenuDisplayPort: 'd-none d-lg-block',
      activeMenu: false
    }
  },
  computed: {
    searchIcon: () => faSearch,
    searchActive() {
      return this.$store.state.registry.getFeature('search')
    },
    loggedIn: function() {
      return this.$store.getters['user/isLoggedIn']
    },
    ecommerceEnabled: function() {
      return this.$store.getters.getEcommerceEnabled
    }
  },
  watch: {
    '$route.fullPath': {
      handler: function(updated, old) {
        if (this.activeMenu) {
          this.triggerMenu()
        }
      }
    }
  },
  created: function() {
    this.$eventHub.$on('hideMobileMenu', this.hideMobileMenu)
    this.$eventHub.$on('showMobileMenu', this.showMobileMenu)
  },
  methods: {
    triggerMenu: function() {
      this.activeMenu = !this.activeMenu

      if (this.activeMenu === true) {
        this.showMobileMenu()
      }
      else {
        this.hideMobileMenu()
      }
    },
    hideMobileMenu: function() {
      this.menuHidden = true
    },
    showMobileMenu: function() {
      this.menuHidden = false
    },
    triggerShowMobileMenuButton: function() {
      this.$eventHub.$emit('showMobileMenu')
    },
    triggerHideMobileMenuButton: function() {
      this.$eventHub.$emit('hideMobileMenu')
    },
    triggerShowHeaderSearch: function() {
      this.$eventHub.$emit('showHeaderSearch')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.mobile-navigation-button {
  background: var(--main-mobile-navigation-button-background-color);
  color: var(--main-mobile-navigation-button-text-color);
  border: 2px solid;
  border-color: var(--main-mobile-navigation-button-border-color);
  @include transition(background-color 0.3s, color 0.3s, border-color 0.3s);
  padding: 0.5rem 1.25rem;
  font-size: 1.1em;
  @include hover-focus {
    background: var(  --main-mobile-navigation-button-hover-background-color);
    color: var( --main-mobile-navigation-button-hover-text-color);
    border-color: var(--main-mobile-navigation-button-hover-border-color);
  }
}

//define active position and transition
//this class poorly discribes what actually happens here

.close-menu {
  cursor: pointer;
  padding: 1em;
  color: var(--main-mobile-navigation-element-text-color);
  background-color: var(--main-mobile-navigation-element-background-color);
  @include transition(background-color 0.3s);
  @include hover-focus {
    background-color: var(
      --main-mobile-navigation-element-background-highlight-color
    );
  }
}

.mobile-navigation {
  position: fixed;
  z-index: 1000;
  top: 0;
}

@include media-breakpoint-down(md) {
  .page-overlay {
    display: none;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    @include transition((opacity 0.3s, z-index 0.3s));

    &.active {
      display: block;
    }
  }
}

//we clear the pageoverlay on media query if the menu hasn't been closed,it prevents the first click on a menu if this isn't set to display none.
.header {
  .page-overlay {
    @include media-breakpoint-up(lg) {
      display: none;
    }
  }
}
.active {
  .header .primary {
    display: block;
  }

  .mobile-navigation-container {
    @include transition(transform 0.4s);
    pointer-events: auto;

    &.left-draw {
      transform: none;
      box-shadow: 5px 0 12px rgba(0, 0, 0, 0.25);
    }

    &.right-draw {
      transform: translateX(0%);
      box-shadow: -5px 0px 12px 0px rgba(0, 0, 0, 0.25);
    }
  }
}

//basic positioning and stucture
.mobile-search {
  padding: 1.5em;
}

.login-title {
  padding: 1.5em;
}

.mobile-user-login {
  padding: 2.5em 3em;
  text-align: center;

  img {
    width: 35%;
    margin-bottom: 1em;
  }
}

.mobile-navigation-container {
  @include transition(transform 0.4s);
  position: relative;
  width: 85%;
  max-width: 460px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  will-change: transform;

  &.left-draw {
    transform: translateX(-100%);
  }

  &.right-draw {
    margin: 0 0 0 auto;
    transform: translateX(100%);
  }

  .navbar {
    padding: 0em;
  }

  .navbar-nav {
    width: 100%;
  }

  .nav {
    width: 100%;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

 ::v-deep .actions {
    //margin-bottom:1.5rem;
    .nav-link,
    .nav-link .btn-link {
      font-size: 1.25rem;
      border-bottom: 1px solid;
      border-color: var(--main-mobile-navigation-border-color);
    }
    .nav-link .btn-link {
      padding: 0;
    }
    .cart,
    .login,
    .portal {
      .icon {
        fill: var(--main-mobile-navigation-link);
      }
    }

    .cart {
      .cart-count {
        border: 1px solid;
        border-color: var(--main-mobile-navigation-border-color);
        margin-left: auto;
        padding: 1rem;
      }
    }
  }
 ::v-deep .nav-item {
    display: flex;
    flex-direction: column;
  }
}

.mobile-navigation-wrapper {
  .mobile-navigation {
    min-height: 600px;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
   ::v-deep .dropdown-toggle {
      &::after {
        margin-left: auto;
      }
    }
   ::v-deep .mobile-navigation-container {
      a {
        display: flex;
        padding: 1rem;
        width: 100%;
        color: var(--main-mobile-navigation-link);
      }

      .btn-link {
        width: 100%;
        .nav-label {
          color: var(--main-mobile-navigation-link);
        }
      }

      ul {
        width: 100%;
        padding: 0em;
        margin: 0em;
      }

      li {
        list-style: none;
      }
      .nav-item {
        h3 {
          padding: 0.75rem 1rem 0.75rem 1.5rem;
          margin-bottom: 0em;
          font-size: 1.25rem;
        }
      }
      .actions {
        .dropdown-menu {
          left: -5px !important;
        }
      }
      .dropdown-menu {
        background: inherit;
        margin-top: -1px;
        position: static;
        border: 0px;
        box-shadow: none;
        width: 100%;
        margin: 0em;
        padding: 0em;
        border-radius: 0px;
        &:before {
          display: none;
        }
        .single-link {
          position: relative;
          display: flex;
          //padding: 1em 1em 1em 1.5em;
        }
      }

      .container {
        padding: 0em;
      }

      .nav-link {
        padding: 0.75rem 1rem;
        display: flex;
        align-items: center;
        @include transition((background-color 0.3s, color 0.3s));
        @include hover-focus {
          background-color: var(
            --main-mobile-navigation-link-background-highlight-color
          );
        }
      }
      .dropdown {
        &.show {
          background-color: var(
            --main-mobile-navigation-link-dropdown-background-color
          );
          position: relative;
          z-index: 2;
          a {
            padding: 0.75rem 1rem;
            display: flex;
            align-items: center;
            color: var(--main-mobile-navigation-link);
            @include transition((background-color 0.3s, color 0.3s));
            @include hover-focus {
              background-color: var(
                --main-mobile-navigation-link-dropdown-background-highlight-color
              );
              color: var(
                --main-mobile-navigation-link-dropdown-background-highlight-link-color
              );
            }
          }
          ul {
            a {
              padding-left: 2rem;
            }
          }
        }
      }

      .primary {
        a {
          font-size: 1.1em;
        }
      }
    }
  }
}
//themeing
.mobile-navigation-container {
  background: var(--main-mobile-navigation-background-color);
}
.mobile-navigation {
  .nav-item {
    .dropdown-toggle {
      &:after {
        opacity: 0.5;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        text-align: right;
        right: 1em;
      }
    }

    &.show {
      > .dropdown-toggle {
        &:after {
          border-bottom: 0.3em solid;
          border-top: 0;
          opacity: 1;
        }
      }
    }
  }

  .dropdown-menu {
    background: inherit;
    margin-top: -1px;
    position: static;
    border: 0px;
    box-shadow: none;
    width: 100%;
    margin: 0em;
    padding: 0em;
  }
}

.dropdown-item {
  white-space: normal;
}
</style>
